// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"2f9d3473","640":"66b67c9d","787":"79065295","845":"962c2809"}[chunkId] + ".chunk.js";
};